import {createContext} from 'react';

export const MarkdownContext = createContext();